var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRightGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "14px",
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved-Designs---Tally-ETA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-step-2b",
    transform: "translate(-308.000000, -221.000000)",
    fill: "#0E730F",
    stroke: "#0E730F",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(10.000000, -229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-62-Copy-2",
    transform: "translate(0.000000, 345.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30-Copy-2",
    transform: "translate(15.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(205.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.7841282,9.59406171 L80.258274,14.7537109 C79.970375,15.0820964 79.5035961,15.0820964 79.2158369,14.7537109 C78.9280544,14.4256175 78.9280544,13.8934816 79.2158369,13.5654148 L83.2205191,8.99991369 L79.2159534,4.43457188 C78.9281708,4.10634573 78.9281708,3.57426297 79.2159534,3.24616961 C79.5037359,2.91794346 79.9704915,2.91794346 80.2583905,3.24616961 L84.7842446,8.40589846 C84.9281359,8.57002481 85,8.78490285 85,8.99988713 C85,9.21497764 84.9279961,9.43001503 84.7841282,9.59406171 Z",
    id: "green"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGreen);
export default __webpack_public_path__ + "static/media/arrow-right-green.45e7d0749005f8bf9de7e753fdfe06d5.svg";
export { ForwardRef as ReactComponent };